export default "__VITE_ASSET__DyN7hvsg__"